export default "__VITE_ASSET__Dqx2AihR__"